const data = [
  {
    id: "1",
    titleItem: "Elecciones del 01 de junio de 2025 – Elección Judicial ",
    description: "Consejero Presidente Emmanuel Ávila González",
    facebookUrl: "https://www.facebook.com/watch/?v=1827089174758517"
  },
  {
    id: "2",
    titleItem: "proceso de contratación de SEL y CAEL para la elección del poder judicial 2025",
    description: "Consejero Electoral Edgar Alfonso Aldave",
    facebookUrl: "https://www.facebook.com/watch/?v=919037563635869"
  },
  {
    id: "3",
    titleItem: "la Red de Mujeres Juzgadoras Candidatas y Electas ",
    description: "Consejera Electoral Janet Cervantes",
    facebookUrl: "https://www.facebook.com/watch/?v=1843692823097652"
  },
  {
    id: "4",
    titleItem: "Documentación electoral para el Proceso Electoral Judicial 2025",
    description: "Consejera Electoral Erika Periañez Rodríguez",
    facebookUrl: "https://www.facebook.com/watch/?v=679614837822726"
  },
  {
    id: "5",
    titleItem: "Listas de candidaturas para el Proceso Electoral Judicial 2025 ",
    description: "Consejera Electoral Anakaren Montserrat Rojas Cuautle",
    facebookUrl: "https://www.facebook.com/watch/?v=1003315381222273"
  },
  {
    id: "6",
    titleItem: "Observadoras y Observadores Electorales ",
    description: "Titular del Área Técnica de Consulta Ciudadana del ITE, Ana Lilia Arévalo,",
    facebookUrl: "https://www.facebook.com/watch/?v=1397259821295969"
  },
  {
    id: "7",
    titleItem: "Topes de gastos personales de campaña para la Elección Judicial Local 2025",
    description: "Consejera Electoral Yedith Martínez Pinillo ",
    facebookUrl: "https://www.facebook.com/watch/?v=9641580825879998"
  },
  {
    id: "8",
    titleItem: "Medidas de seguridad que se emplearán en las boletas electorales del Proceso Electoral Local Extraordinario 2025. ",
    description: "Consejera Electoral Erika Periañez Rodríguez, ",
    facebookUrl: "https://www.facebook.com/watch/?v=664192972999442"
  },
  {
    id: "9",
    titleItem: "foros de debate para el Proceso Electoral Local Extraordinario 2025.",
    description: "Consejero Electoral Edgar Alfonso Aldave Aguilar",
    facebookUrl: "https://www.facebook.com/watch/?v=659838563569623"
  },
  {
    id: "10",
    titleItem: "Consejos distritales y su importancia para el Proceso Electoral Local Extraordinario 2025",
    description: "Consejera Electoral Anakaren Monserrat Rojas",
    facebookUrl: "https://www.facebook.com/watch/?v=1778791369645286"
  },
  {
    id: "11",
    titleItem: "Sistema Candidatas y Candidatos Conóceles",
    description: "Consejero Electoral Hermenegildo Neria Carreño",
    facebookUrl: "https://www.facebook.com/watch/?v=942003187880914"
  },
  {
    id: "12",
    titleItem: "Foros de Debate del Proceso Electoral Local Extraordinario 2025",
    description: "Consejero Electoral Edgar Alfonso Aldave Aguilar",
    facebookUrl: "http://facebook.com/watch/?v=690773446773482"
  },
  {
    id: "13",
    titleItem: "Importancia de la Participación Ciudadana en el Proceso Electoral Local Extraordinario 2025 ",
    description: "Consejera Electoral Yedith Martínez Pinillo ",
    facebookUrl: "https://www.facebook.com/watch/?v=719904494049077"
  },
  {
    id: "14",
    titleItem: "como votar en esta Elección Judicial Local 2025",
    description: "Consejera Electoral Anakaren Rojas Cuautle ",
    facebookUrl: "https://www.facebook.com/watch/?v=1943706939787986"
  },
  {
    id: "15",
    titleItem: "Jornada Electoral de este 01 de junio ",
    description: "Consejero Electoral Edgar Alfonso Aldave",
    facebookUrl: "https://www.facebook.com/watch/?v=1682433845967294"
  },
  {
    id: "16",
    titleItem: "Cómputos de la Elección Judicial Local 2025 ",
    description: "Consejera Electoral Anakaren Rojas Cuautle",
    facebookUrl: "https://www.facebook.com/watch/?v=688707017308812"
  },
  {
    id: "17",
    titleItem: "Requisitos de Elegibilidad de la Elección Judicial Local 2025",
    description: "Consejera Electoral Janet Cervantes",
    facebookUrl: "https://www.facebook.com/watch/?v=1881850845999519",
  },
  {
    id: "18",
    titleItem: "La participación política de la comunidad LGBTTIQ+",
    description: "Heizel Sánchez Nava, Integrante del Comité de la Diversidad en Tlaxcala",
    facebookUrl: "https://www.facebook.com/watch/?v=3932969903699883",
  },
  {
    id: "19",
    titleItem: "Violencia Política contra las Mujeres en razón de Género",
    description: "Regidora del Ayuntamiento de Cuapiaxtla María Isabel Bautista",
    facebookUrl: "https://www.facebook.com/watch/?v=750049791292956",
  },
  {
    id: "20",
    titleItem: "70 aniversario del Sufragio Femenino en México.",
    description: "Consejera Electoral Erika Periañez",
    facebookUrl: "https://www.facebook.com/watch/?v=30801039016176692",
  },
  {
  id: "21",
  titleItem: "Concurso Nacional de Oratoria 2025",
  description: "Consejera Electoral Yedith Martínez Pinillo",
  facebookUrl: "https://www.facebook.com/reel/778264477869286",
},
{
  id: "22",
  titleItem: "XIV Parlamento Juvenil Tlaxcala 2025",
  description: "Bibiana Sánchez Romero",
  facebookUrl: "https://www.facebook.com/reel/1529603558450069",
},
{
  id: "23",
  titleItem: "Orgullo y raíces otomíes",
  description: "Justino Tzoni",
  facebookUrl: "https://www.facebook.com/reel/1060941609355801",
},
{
  id: "24",
  titleItem: "Experiencia y preparación",
  description: "Adolfo Hernández Hernández",
  facebookUrl: "https://www.facebook.com/reel/759299406468194",
},
{
  id: "25",
  titleItem: "Emprender siendo joven",
  description: "Marián Bernal",
  facebookUrl: "https://www.facebook.com/reel/1482617272762764",
},
{
  id: "26",
  titleItem: "Magistrada Infantil en el Tribunal Electoral de la Federación 2025",
  description: "Samantha Domínguez Gachupín",
  facebookUrl: "https://www.facebook.com/reel/813698114423567",
},
{
  id: "27",
  titleItem: "Premio Estatal de la Juventud 2025",
  description: "José Roberto Gómez Vázquez",
  facebookUrl: "https://www.facebook.com/reel/1274387173962213",
},
{
  id: "28",
  titleItem: "Violencia Política contra las Mujeres en Razón de Género",
  description: "Rocío Itzel Martínez González",
  facebookUrl: "https://www.facebook.com/reel/1159367862915924",
},
{
  id: "29",
  titleItem: "3ra Semana Estatal de Educación Cívica",
  description: "Consejero Electoral Edgar Alfonso Aldave Aguilar",
  facebookUrl: "https://www.facebook.com/reel/613672285017005",
},
{
  id: "30",
  titleItem: "Memoria Electoral de los Procesos Electorales Local Ordinario 2023-2024 y Local Extraordinario 2024",
  description: "Consejero Presidente Emmanuel Ávila González",
  facebookUrl: "https://www.facebook.com/reel/1796677597887257",
},
{
  id: "31",
  titleItem: "Participación política de las juventudes en la vida pública",
  description: "Carmen Tlatelpa Juárez",
  facebookUrl: "https://www.facebook.com/reel/1208505107780305",
},
{
  id: "32",
  titleItem: "Historia Breve del Órgano Constitucional Autónomo Electoral Local",
  description: "Elizabeth González Serrano",
  facebookUrl: "https://www.facebook.com/reel/4115082808707313",
},
{
  id: "33",
  titleItem: "Trayectoria y experiencia en el fortalecimiento de la democracia tlaxcalteca",
  description: "Consejera Electoral Erika Periañez Rodríguez",
  facebookUrl: "https://www.facebook.com/reel/1334515038131946",
},
{
  id: "34",
  titleItem: "Trayectoria y experiencia en el fortalecimiento de la democracia tlaxcalteca",
  description: "Consejero Electoral Edgar Alfonso Aldave Aguilar",
  facebookUrl: "https://www.facebook.com/reel/974779131590814",
},
{
  id: "35",
  titleItem: "Proceso de designación como integrante del colegiado del ITE",
  description: "Consejera Electoral Brenda Fernanda Barrón Rugerio",
  facebookUrl: "https://www.facebook.com/reel/830096073523955",
},
{
  id: "36",
  titleItem: "Democracia en Señas: Compromiso Institucional con la Inclusión",
  description: "Consejera Electoral Yedith Martínez Pinillo",
  facebookUrl: "https://www.facebook.com/reel/1401720748399525",
},
{
  id: "37",
  titleItem: "Desincorporación de material electoral del Proceso Electoral Local Extraordinario 2024-2025",
  description: "Nancy García Ramírez",
  facebookUrl: "https://www.facebook.com/reel/1566057237903861",
},
{
  id: "38",
  titleItem: "Acceso a la información con perspectiva de derechos",
  description: "Consejera Electoral Janet Cervantes Ahuatzi",
  facebookUrl: "https://www.facebook.com/reel/1517488756128088",
},
{
  id: "39",
  titleItem: "Civicon 2025",
  description: "Consejero Presidente Emmanuel Ávila González",
  facebookUrl: "https://www.facebook.com/reel/4174469296142979",
},
{
  id: "40",
  titleItem: "Firma de convenios entre el ITE y los ayuntamientos del estado",
  description: "Consejero Electoral Hermenegildo Neria Carreño",
  facebookUrl: "https://www.facebook.com/reel/1572295427428246",
},
{
  id: "41",
  titleItem: "Percepción de las juventudes sobre los procesos electorales",
  description: "Consejera Electoral Yedith Martínez Pinillo",
  facebookUrl: "https://www.facebook.com/reel/886817317104603",
},
{
  id: "42",
  titleItem: "Comunidades que llevan a cabo elecciones por el Sistema de Usos y Costumbres",
  description: "Consejera Electoral Anakaren Rojas",
  facebookUrl: "https://www.facebook.com/reel/861211560058333",
},
{
  id: "43",
  titleItem: "Rumbo a la construcción de acciones afirmativas y autoadscripción de la comunidad LGBTTTIQA+",
  description: "Consejera Electoral Janet Cervantes Ahuatzi",
  facebookUrl: "https://www.facebook.com/reel/3131868256995182",
},
{
  id: "44",
  titleItem: "Fake News",
  description: "Paola Torres",
  facebookUrl: "https://www.facebook.com/reel/896247169448800",
},
{
  id: "45",
  titleItem: "Elecciones Escolares",
  description: "Mario Jiménez",
  facebookUrl: "https://www.facebook.com/reel/1337433824814196",
},
{
  id: "46",
  titleItem: "Multas a partidos políticos",
  description: "Consejera Electoral Yedith Martínez Pinillo",
  facebookUrl: "https://www.facebook.com/reel/930071176637113",
},
{
  id: "47",
  titleItem: "Therians",
  description: "Carmen Flores Moreno",
  facebookUrl: "https://www.facebook.com/reel/1243375030551598",
},
{
  id: "48",
  titleItem: "Mujeres Indígenas",
  description: "Catalina Gachupin Flores",
  facebookUrl: "https://www.facebook.com/reel/1572908570660134",
},
{
  id: "49",
  titleItem: "Participación de las Mujeres en el ámbito político electoral",
  description: "Consejera Electoral Brenda Fernanda Barrón Rugerio",
  facebookUrl: "https://www.facebook.com/reel/786470164510669",
},
{
  id: "50",
  titleItem: "Red de mujeres candidatas y electas",
  description: "Consejera Electoral Janet Cervantes Ahuatzi",
  facebookUrl: "https://www.facebook.com/reel/1263891145711688",
},
{
  id: "51",
  titleItem: "Financiamiento a partidos políticos",
  description: "Consejera Electoral Yedith Martínez Pinillo",
  facebookUrl: "https://www.facebook.com/reel/1469425208240382",
},
{
  id: "52",
  titleItem: "Mujeres Sordas",
  description: "Jaqueline Amador",
  facebookUrl: "https://www.facebook.com/reel/938412775497503",
},
{
  id: "53",
  titleItem: "Consultas",
  description: "Consejera Electoral Brenda Fernanda Barrón Rugerio",
  facebookUrl: "https://www.facebook.com/reel/932867059645879",
},
{
  id: "54",
  titleItem: "Consultas a la población LGBTTTIQA+",
  description: "Daiana Ramírez Lara",
  facebookUrl: "https://www.facebook.com/reel/2236443576886122",
},
{
  id: "55",
  titleItem: "Infancias Indígenas",
  description: "Samantha y Saúl",
  facebookUrl: "https://www.facebook.com/reel/1968618477195992",
},
{
  id: "56",
  titleItem: "Consultas Indígenas",
  description: "Antonio Dávila",
  facebookUrl: "https://www.facebook.com/reel/3500733420082436",
},
{
  id: "57",
  titleItem: "Consultas LGBTTTIQA+",
  description: "Consejera Electoral Yedith Martínez Pinillo",
  facebookUrl: "https://www.facebook.com/reel/1508962544492225",
},
{
  id: "58",
  titleItem: "Fundación Hans Asperger A.C.",
  description: "Gema Paredes",
  facebookUrl: "https://www.facebook.com/reel/808710115456381",
  nuevo: "1" 
},

];

// Ordenar de mayor a menor por id (conversión a número para evitar errores)
export const EnCorto = data.sort((a, b) => Number(b.id) - Number(a.id));
